import { render, staticRenderFns } from "./AttendanceForm.vue?vue&type=template&id=b40810f2"
import script from "./AttendanceForm.vue?vue&type=script&lang=js"
export * from "./AttendanceForm.vue?vue&type=script&lang=js"
import style0 from "./AttendanceForm.vue?vue&type=style&index=0&id=b40810f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports